/**
 * Onboarding: welkomstvenster, "Getting started" en rondleidingen.
 * Contract: docs/ONBOARDING.md (siq_auth, route `Onboarding`).
 */

/** `bestaand` = gebruiker van vóór de onboarding (de migratie zette hem zo). */
export type OnboardingStatus = 'nieuw' | 'ingevuld' | 'overgeslagen' | 'bestaand';

/** Vaste profielsleutels; de naam staat in i18n (ONBOARDING.profielen). */
export type OnboardingProfiel = 'coach' | 'analyst' | 'club_admin' | 'player' | 'manager' | 'scout';

/** Vraag 2, meerdere mogelijk. De volgorde ligt vast in het contract. */
export const ONBOARDING_DOELEN = ['opnemen', 'uploaden', 'taggen', 'stats', 'playlists'] as const;
export type OnboardingDoel = typeof ONBOARDING_DOELEN[number];

/** De taken in "Getting started", elk met een rondleiding. */
export type OnboardingWorkflow = 'upload' | 'plannen' | 'taggen' | 'playlists';

export interface IOnboardingProfielInstelling {
  sleutel: OnboardingProfiel | string;
  /** Workflowsleutels, in de volgorde waarin ze op de kaart staan. */
  workflows: string[];
}

export interface IOnboardingWorkflowInstelling {
  sleutel: OnboardingWorkflow | string;
  /** Openbare playlist-link van PlayStats; null = geen video. */
  videoUrl: string | null;
  /** Voor "2 min". */
  minuten: number;
}

/** Antwoord van GET /Onboarding/Me (en van elke PUT daaronder). */
export interface IOnboardingMe {
  /** Geen rij of status `nieuw`: het welkomstvenster openen. */
  tonen: boolean;
  status: OnboardingStatus;
  profiel: string | null;
  doelen: string[];
  team: string | null;
  klaar: string[];
  verborgen: boolean;
  /** Alleen de actieve profielen, op volgorde. */
  profielen: IOnboardingProfielInstelling[];
  workflows: IOnboardingWorkflowInstelling[];
}

/** Body van PUT /Onboarding/Me. */
export interface IOnboardingAntwoord {
  profiel: string | null;
  doelen: string[];
  team: string | null;
  overgeslagen: boolean;
}
